import { Badge } from "@/components/ui/baseUi/badge"
import { word } from "@/modules/core/utils/i18n"
import { ResumeCardPriceDisplay } from "@/modules/finances/components/resumeCardPriceDisplay"
import type { FinanceStatisticsEntity } from "@/modules/finances/entities/financeStatisticsEntity"
import { createPaymentsToValidateSummaryModel } from "@/modules/finances/paymentsToValidate/models/paymentsToValidateModel"
import { cn } from "@/modules/lib/utils"

export type PaymentsToValidateResumeCardProps = {
  stats: FinanceStatisticsEntity | null
  className?: string
} & React.ComponentProps<"div">

export function PaymentsToValidateResumeCard({ stats, className, ...props }: PaymentsToValidateResumeCardProps) {
  const { paymentToValidate, paymentFailed, paymentDisputed } = createPaymentsToValidateSummaryModel(stats, true)

  return (
    <div
      className={cn(
        "flex min-h-30 w-fit flex-row items-center justify-start gap-12 overflow-hidden rounded-4xl bg-surface-background-secondary p-4 md:p-8",
        className,
      )}
      {...props}
    >
      {/* PAYMENT TO VALIDATE TOTAL AMOUNT */}
      <div className="flex flex-col overflow-hidden">
        <ResumeCardPriceDisplay
          price={{ value: paymentToValidate.total, currency: stats?.stats.currency ?? "" }}
          wholePartFontStyle="HS"
          decimalPartFontStyle="TL"
          wholePartClassName="text-textOnSurface-subtle"
          decimalPartClassName="text-textOnSurface-subtle"
        />
        <Badge variant={paymentToValidate.badgeVariant} size="lg">
          {`${paymentToValidate.count.toString()} ${word("finances.page.paymentToValidate.summaryCard.actionRequired", { count: paymentToValidate.count })}`}
        </Badge>
      </div>

      {/* PAYMENT FAILED AMOUNT */}
      <div className="flex flex-col overflow-hidden">
        <ResumeCardPriceDisplay
          price={{ value: paymentFailed.total, currency: stats?.stats.currency ?? "" }}
          wholePartFontStyle="HS"
          decimalPartFontStyle="TL"
          wholePartClassName="text-textOnSurface-subtle"
          decimalPartClassName="text-textOnSurface-subtle"
        />
        <Badge variant={paymentFailed.badgeVariant} size="lg">
          {`${paymentFailed.count.toString()} ${word("finances.page.paymentToValidate.summaryCard.failed", { count: paymentFailed.count })}`}
        </Badge>
      </div>

      {/* PAYMENT DISPUTED AMOUNT */}
      <div className="flex flex-col overflow-hidden">
        <ResumeCardPriceDisplay
          price={{ value: paymentDisputed.total, currency: stats?.stats.currency ?? "" }}
          wholePartFontStyle="HS"
          decimalPartFontStyle="TL"
          wholePartClassName="text-textOnSurface-subtle"
          decimalPartClassName="text-textOnSurface-subtle"
        />
        <Badge variant={paymentDisputed.badgeVariant} size="lg">
          {`${paymentDisputed.count.toString()} ${word("finances.page.paymentToValidate.summaryCard.disputed", { count: paymentDisputed.count })}`}
        </Badge>
      </div>
    </div>
  )
}
